"use client";
import { Layout, Menu, Typography } from "antd";
import { DashboardOutlined, FileTextOutlined, BarChartOutlined, TransactionOutlined, DollarOutlined } from "@ant-design/icons";
import { usePathname, useRouter } from "next/navigation";

const { Header, Sider, Content } = Layout;
const { Title } = Typography;

export default function ClientLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  const pathname = usePathname();
  const router = useRouter();

  const menuItems = [
    {
      key: "/",
      icon: <DashboardOutlined />,
      label: "仪表盘",
      onClick: () => router.push("/"),
    },
    {
      key: "/tasks",
      icon: <FileTextOutlined />,
      label: "任务管理",
      onClick: () => router.push("/tasks"),
    },
    {
      key: "/commission",
      icon: <DollarOutlined />,
      label: "佣金管理",
      onClick: () => router.push("/commission"),
    },
    {
      key: "/visits",
      icon: <BarChartOutlined />,
      label: "访问统计",
      onClick: () => router.push("/visits"),
    },
    {
      key: "/transactions",
      icon: <TransactionOutlined />,
      label: "交易统计",
      onClick: () => router.push("/transactions"),
    },
  ];

  return (
    <Layout className="h-full">
      <Sider width={250} theme="dark">
        <div className="h-16 flex items-center justify-center">
          <Title level={4} className="text-white m-0">AgentEx 管理后台</Title>
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[pathname]}
          items={menuItems}
        />
      </Sider>
      <Layout>
        <Header className="bg-white px-6 flex items-center justify-end shadow-sm">
          <div className="text-gray-600">欢迎使用运营管理系统</div>
        </Header>
        <Content className="p-6 bg-gray-50 overflow-auto">
          {children}
        </Content>
      </Layout>
    </Layout>
  );
}
